import EXIF from "exif-js/exif"

const base64ToArrayBuffer = (base64: string) => {
  base64 = base64.replace(/^data:([^;]+);base64,/gim, "")
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes.buffer
}

const getExif = (base64stringImage: string) => {
  return EXIF.readFromBinaryFile(base64ToArrayBuffer(base64stringImage))
}

export const getImageOrientation = (
  base64string: string,
): 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | null => {
  return getExif(base64string).Orientation || null
}
